import IconShare from 'asset/icon-share.svg'
import { Modal } from 'component/Modal'
import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { HeaderAction } from 'page/catalog/HeaderAction/HeaderAction'
import { SharePanel } from 'page/catalog/SharePanel/SharePanel'
import { useState } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'

export const ShareButton = observer(() => {
  const { small } = ui.window
  const [open, setOpen] = useState(false)

  const onShare = useLatestCallback(async () => {
    try {
      const title = document.title
      const text = ''
      const url = location.href
      const shareData: ShareData = { title, text, url }
      if (navigator.canShare && navigator.canShare(shareData)) {
        await navigator.share(shareData)
      }
    } catch (e) {
      console.error('share failed', e)
    }
  })

  const onClick = useLatestCallback(() => {
    if (small) void onShare()
    else setOpen(true)
  })

  const onClose = useLatestCallback(() => {
    setOpen(false)
  })

  return <>
    <HeaderAction icon={<IconShare />} label={i18n('share.Share')} action={onClick} />
    {open && <Modal onCancel={onClose} white>
      <Vertical pad={24}>
        <Typo size={16} medium center>{i18n('share.Share')}</Typo>
        <Gap height={16} />
        <SharePanel onClose={onClose} />
      </Vertical>
    </Modal>}
  </>
})
